export enum ErrorCode {

    DepositLimits = 13143,
}
